import {
  Component,
  Input,
  Output,
  OnChanges,
  EventEmitter,
  ChangeDetectionStrategy,
} from "@angular/core";
const sortBy = require("lodash/sortBy"); // tslint:disable-line

import {
  Validators,
  FormControl,
  FormBuilder,
  FormGroup,
} from "@angular/forms";
// ngrx/store
import { Store } from "@ngrx/store";
import * as fromRoot from "../../reducers";

// Actions
import * as CompanyAnalysisActions from "../../actions/company-analysis.actions";
import * as users from "../../actions/user.actions";

import "rxjs/add/observable/of";
import { Observable } from "rxjs/Observable";
import { Subscription } from "rxjs/Subscription";
import "rxjs/add/operator/catch";
const isMatch = require("lodash/isMatch"); // tslint:disable-line
const isEqualWith = require("lodash/isEqualWith"); // tslint:disable-line
const isEqual = require("lodash/isEqual"); // tslint:disable-line

@Component({
  selector: "top-filter-control",
  templateUrl: "top-filter-control.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TopFilterControlComponent implements OnChanges {
  @Input() sectors: any = [];
  @Input() regions: any = [];
  @Input() upperFilter: any = {};
  @Input() lowerFilter: any = {};
  @Input() dataRanges: any = {};
  @Output() updateFilter: EventEmitter<any> = new EventEmitter<any>();
  industries: any[];
  countries: any[];
  sector: string;
  industry: string;
  region: string;
  country: string;
  marketCaps: any[] = [
    { name: "< 2 Billion USD", value: { $lte: 2 } },
    { name: ">= 5 Billion USD", value: { $gte: 5 } },
    { name: "2 - 10", value: { $gte: 2, $lte: 10 } },
    { name: "10 -50", value: { $gte: 10, $lte: 50 } },
    { name: "> 50", value: { $gte: 50 } },
  ];

  _filter: any = {};

  filterSubscription: Subscription;

  initialised: boolean = false;

  private filterForm: FormGroup;
  public hasFormError: boolean = false;

  public receivedFilter: any;

  constructor(public store: Store<fromRoot.State>, public fb: FormBuilder) {}

  // *************
  // Triggers when passed-in values change
  // *************
  ngOnChanges() {
    if (!this.upperFilter) return;

    this.receivedFilter = JSON.parse(
      JSON.stringify({ ...{ screens: {} }, ...this.upperFilter })
    );

    this.initialised = false;
    if (this.upperFilter.screens && this.upperFilter.screens.sector)
      this.setIndustries(this.upperFilter.screens.sector);
    if (this.upperFilter.screens && this.upperFilter.screens.region)
      this.setCountries(this.upperFilter.screens.region);

    if (
      this.upperFilter &&
      this.upperFilter.screens &&
      this.upperFilter.screens.marketCapB
    ) {
      this.updateMarketCapB(this.upperFilter.screens.marketCapB);
    }

    this.initialiseForm();

    setTimeout(() => {
      this.filterSubscription = this.filterForm.valueChanges
        .filter((v) => {
          return v !== undefined;
        })
        .debounceTime(500)
        .subscribe(
          (data) => this.onFormValueChanged(data),
          (err) => {
            console.log(err);
          }
        );
      this.initialised = true;
    }, 2000);
  }

  ngOnDestroy() {
    if (this.filterSubscription) this.filterSubscription.unsubscribe();
  }

  initialiseForm() {
    if (!this.upperFilter) return;

    let mktCap = this.upperFilter.screens
      ? this.upperFilter.screens.marketCapB
      : "All Values";

    if (mktCap && mktCap["$lte"] && mktCap["$lte"] == 2) mktCap = 0;
    if (mktCap && mktCap["$gte"] && mktCap["$gte"] == 5) mktCap = 1;
    if (mktCap && mktCap["$gte"] && mktCap["$gte"] == 2) mktCap = 2;
    if (mktCap && mktCap["$gte"] && mktCap["$gte"] == 10) mktCap = 3;
    if (mktCap && mktCap["$gte"] && mktCap["$gte"] == 50) mktCap = 4;

    this.filterForm = this.fb.group({
      marketCapB: mktCap,

      sector: this.upperFilter.screens
        ? this.upperFilter.screens.sector
        : "All Sectors",
      industry: this.upperFilter.screens
        ? this.upperFilter.screens.industry
        : "All Industries",
      region: this.upperFilter.screens
        ? this.upperFilter.screens.region
        : "All Regions",
      country: this.upperFilter.screens
        ? this.upperFilter.screens.country
        : "All Countries",
    });
  }

  updateMarketCapB(marketCap) {
    if (marketCap == { $exists: true }) {
      marketCap = undefined;
    } else {
    }
  }

  onFormValueChanged(data) {
    if (!data) return;

    this.filterForm.markAsPristine();
    this.filterForm.markAsUntouched();
    this._updateFilter(data);
  }

  updateSector(sector) {
    this.filterForm.controls["industry"].setValue(undefined);
    setTimeout(() => {
      if (sector == "All Sectors") sector = undefined;
      this.setIndustries(sector);
    }, 500);
  }

  updateIndustry(industry) {
    if (industry == "All Industries") industry = undefined;
    // this.filter = { ...this.filter, ...{ screens: { industry } } };
  }

  updateRegion(region) {
    // this.filter = { ...this.filter, ...{ screens: { region } } };
    this.filterForm.controls["country"].setValue(undefined);
    setTimeout(() => {
      if (region == "All Regions") region = undefined;
      this.setCountries(region);
    }, 500);
  }
  updateCountry(country) {
    if (country == "All Countries") country = undefined;
    // this.filter = { ...this.filter, ...{ screens: { country } } };
  }

  _updateFilter(d) {
    if (!this.initialised) return;
    //Remove All x
    // this.filter.screens['marketCap'] = undefined;

    let data = { ...d };

    if (
      (data.marketCapB !== 0 && !data.marketCapB) ||
      data.marketCapB == "All Values"
    )
      delete data.marketCapB;

    //Convert the text to json if theere is a market cap
    if (data.marketCapB || data.marketCapB === 0) {
      data.marketCapB = this.marketCaps[data.marketCapB].value;
    }

    if (!data.sector && isEmpty(data.sector)) delete data.sector;
    if (!data.industry && isEmpty(data.industry)) delete data.industry;
    if (!data.region && isEmpty(data.region)) delete data.region;
    if (!data.country && isEmpty(data.country)) delete data.country;

    if (data.sector && data.sector === "All Sectors") delete data.sector;
    if (data.industry && data.industry === "All Industries")
      delete data.industry;
    if (data.region && data.region === "All Regions") delete data.region;
    if (data.country && data.country === "All Countries") delete data.country;

    //Clean up all the screening data
    // this.formFields.forEach(f => {
    //   //Are there values?
    //   if (data[f.name]) {

    //     Object.keys(data[f.name]).forEach(i => {
    //       //Check if null
    //       if (isEmpty(data[f.name][i])) {
    //         delete data[f.name][i];
    //       } else {
    //         data[f.name][i] = data[f.name][i] / this.formFieldsObj[f.name].displayFactor;
    //       }
    //     })

    //     if (Object.keys(data[f.name]).length == 0) {
    //       delete data[f.name];
    //     }
    //   }
    // })

    let updatedFilterUpper = { ...this.receivedFilter, ...{ screens: data } };
    let updatedFilterLower = { ...this.lowerFilter, ...{ screens: data } };

    this.updateFilter.emit(updatedFilterUpper);
    this.updateFilter.emit(updatedFilterLower);
  }

  _resetFilter() {
    // this.filter.screens['marketCap'] = undefined;
    let updatedFilter = { ...this.upperFilter };
    updatedFilter.screens = {};
    this.updateFilter.emit(updatedFilter);
  }

  setIndustries(sector) {
    if (this.sectors.length == 0) return;
    try {
      if (!sector) {
        this.industries = [];
        this.sectors.map((s) => {
          this.industries.push(...s.industries);
        });
      } else {
        this.industries = this.sectors.find(
          (s) => s.name === sector
        ).industries;
      }
      this.industries = sortBy(this.industries, (i) => i.name);
    } catch (e) {
      console.error("Errorindustries in filter control setting:", e);
    }
  }
  setCountries(region) {
    if (!region) {
      this.countries = [];
      return;
    }

    this.countries = this.regions.find((s) => s.name === region)
      ? this.regions.find((s) => s.name === region).countries
      : [];
  }
}

function isEmpty(val) {
  let lreturn: boolean;

  if (val == 0) lreturn = false;
  lreturn =
    isNaN(val) || val === undefined || val == null || val.length <= 0
      ? true
      : false;
  return lreturn;
}

function isJSON(data) {
  var ret = true;
  try {
    JSON.parse(data);
  } catch (e) {
    ret = false;
  }
  return ret;
}



// WEBPACK FOOTER //
// ./src/components/top-filter-control/top-filter-control.ts